export default __webpack_public_path__ + "static/media/MobileLife.13567e18.svg";